// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Go1M55PJWpueLLtD-dLwhw\\=\\={margin-bottom:0 !important}", "",{"version":3,"sources":["webpack://./components/Typography/Paragraph/styles.module.scss"],"names":[],"mappings":"AAAA,4BACE,0BAAA","sourcesContent":[".noMargin {\n  margin-bottom: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noMargin": "Go1M55PJWpueLLtD-dLwhw=="
};
export default ___CSS_LOADER_EXPORT___;
